const home_CN = {
  hello: '你好，世界！',
  name: '我的名字是 {name}',
  home_workbench: '工作台',
  home_wish: '祝你开心每一天！',
  home_terminal_management: '终端管理',
  home_top_up_query: '充值查询',
  home_quick_navigation: '快捷导航',
  home_dynamic: '动态',
  home_construction: '施工中...',
};

export default home_CN;